// @flow

import {useContext} from 'react';
import {AdditionalInformationContext} from '../AdditionalInformationContext';

import type {AdditionalInformationData} from '../AdditionalInformationContext';

export const useAdditionalInformationContext = () => {
  return useContext<AdditionalInformationData>(AdditionalInformationContext);
};
